import {combineReducers} from "redux";
import userReducer from "./userReducer";
import caseReducer from "./caseReducer";
import translationReducer from "./translationReducer";

const rootReducers = combineReducers({
    userReducer, caseReducer, translationReducer
});

export default rootReducers;